import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Keyboard, KeyboardResizeMode } from '@awesome-cordova-plugins/keyboard/ngx';
import { NavController } from '@ionic/angular';
import { ReturnNativeService } from '../../../../app/shared/service/comunicator-native/return-native/return-native';
import { AnalyticsPageModel } from '../../../shared/model/analyticsPage';
import { DefaultPageComponent } from '../../../shared/page/default-page.component';
import { AnalyticsGA4PageService } from '../../../shared/service/analytics-ga4-pages/analytics-ga4-page.service';
import { AnalyticsGA4PagesModel } from '../../../shared/service/analytics-ga4-pages/analytics-ga4-pages-models';
import { AnalyticsPageService } from '../../../shared/service/analytics/analytics-page.service';
import { AnalycticsNativeService } from '../../../shared/service/comunicator-native/analytics-native/analyctics-native';
import { BackNativeService } from '../../../shared/service/comunicator-native/back-native/back-native';
import { DomainFactoryService } from "../../../shared/service/domains/domain-factory-service";
import { DomainDataType } from "../../../shared/service/domains/model/domain-data-type";
import { JourneyService } from '../../../shared/service/journey/journey.service';
import { TrackTypes } from "../../../shared/service/journey/tracks/model/track-types";
import { LogService } from "../../../shared/service/log/log.service";
import { ValueSort } from "../../../shared/sort-funcions/value-sort";
import { RadioModel } from '../../model/radio.model';
import { PersonalDataService } from '../../service/personal-data.service';

@Component({
  selector: 'app-birth-city',
  templateUrl: './birth-city.component.html',
  styleUrls: ['./birth-city.component.scss'],
})
export class BirthCityComponent extends DefaultPageComponent implements OnInit {

  selectedItem = '';
  selectedName = '';
  textSearch: string;
  public idComponentName = 'birthCity';
  buttonEnable = false;
  idLabel = 'nameCityLabel';
  label = 'Nome da cidade';
  fieldSearch = 'value';
  startStage = '';
  endStage = '';
  loading = true;
  showRetry = false;
  birthCity = new Array<RadioModel>();
  @ViewChild('content') content: ElementRef;

  headerId = 'birth-city';
  titlePage = 'Dados pessoais';
  analyticsPage: AnalyticsPageModel;
  analyticsPageGA4: AnalyticsGA4PagesModel;
  sendAnalyticsFirstView = false;

  constructor(
    public router: NavController,
    private personalDataService: PersonalDataService,
    public backNativeService: BackNativeService,
    public journeyService: JourneyService,
    private title: Title,
    private logService: LogService,
    public returnNativeService: ReturnNativeService,
    public analycticsNativeService: AnalycticsNativeService,
    private keyBoard: Keyboard,
    private domainFactory: DomainFactoryService,
    private analyticsPageService: AnalyticsPageService,
    private analyticsGA4PageService: AnalyticsGA4PageService,
    ) {
    super(backNativeService, journeyService, router, returnNativeService);
    this.getAnalyticsPage();
    this.getAnalyticsPageGA4();
    this.configureDomain(null, DomainDataType.City);
    this.getTrack();
    this.keyBoard.setResizeMode(KeyboardResizeMode.Body);
  }

  /* istanbul ignore next */
  ngOnInit() {
    this.setTitle();
    this.headerFocus();
    this.getDomainCity();
    this.editFieldInvest('cidade_nascimento', 'cityOfBirth', 'personalData');
  }

  getAnalyticsPage() {
    this.analyticsPage = this.analyticsPageService.setAnalyticsPage();
  }

  getAnalyticsPageGA4() {
    this.analyticsPageGA4 = this.analyticsGA4PageService.setAnalyticsPageGA4();
  }

  getTrack() {
    const track = this.journeyService.selectedTrack;
    const path = 'personal-data';

    if (this.journeyService.journey === TrackTypes.CONTA_ION ||
      this.journeyService.journey === TrackTypes.CONTA_ION_PERSONAL) {
      this.startStage = '10';
      this.endStage = '11';
    } else {
      this.startStage = (track.getIndexPage(this.headerId, path) - 1).toString();
      this.endStage = (track.getTotalPage(path) - 1).toString();
    }
  }

  analyticsData() {
    const it_pagename = this.analyticsPage.birthCity;
    this.analycticsNativeService.analyticsTrackStateCommunicator(it_pagename);
  }

  sendTrackGA4LoadPage() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameScreenView,
      custom_path: this.analyticsPageGA4.customPathCidadeNascimento,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    }

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl)
  }

  sendTrackGA4LoadPageError() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameAlert,
      custom_path: this.analyticsPageGA4.customPathCidadeNascimento,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    }
    const paramComplementary = {
      detail: 'tipo:tela',
      description: this.analyticsPageGA4.titleError, 
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl, paramComplementary)
  }

  setTitle() {
    this.title.setTitle(this.titlePage);
  }

  clickNext() {
    /* tslint:disable:no-string-literal */
    this.sendAnalyticsFirstView = true;
    this.personalDataService.setBirthCity(this.selectedItem);
    this.personalDataService.setBirthCityName(this.selectedName);
    this.nextPage();
  }

  analyticsEventClique() {
    const it_eventcategory = 'Clique';
    const it_complementary = {
              it_eventaction: this.analyticsPage.action,
              it_eventlabel: this.analyticsPage.back,
              it_pagename: this.analyticsPage.birthCity
           };
    this.analycticsNativeService.analyticsTrackActionCommunicator(it_eventcategory, it_complementary);
  }

  getPageId(): string {
    return this.headerId;
  }

  ionViewWillEnter() {
    this.headerFocus();
    this.setEditPageRegistratio();

    if (this.sendAnalyticsFirstView) {
      this.analyticsData();
      this.sendTrackGA4LoadPage();
    }
  }

  ionViewDidLeave() {
    this.textSearch = '';
    this.birthCity = this.orderList(this.birthCity, this.selectedItem);
    this.ariaHidden = true;
  }

  setEditPageRegistratio() {
    if (this.journeyService.registratioJourney.data.personalData?.cityOfBirth &&
        !this.personalDataService.changeBirthState) {
      this.selectedItem = this.journeyService.registratioJourney.data.personalData.cityOfBirth;
      this.selectedName = this.journeyService.registratioJourney.data.personalData.cityOfBirthName;
    }
  }
  

  getDomainCity() {
    this.logService.save(this.journeyService.registratioJourney.data.personalData.uFOfBirth, 'BirthCityComponent.getDomainCity')

    const filterCity = this.journeyService.registratioJourney.data.personalData.uFOfBirth;
    this.logService.save(filterCity, 'BirthCityComponent.getDomainCity')

    this.domainFactory.getDomainService(this.domainOrigin)
    .getDomains(this.domainDataType, filterCity).then((dominios) => {
      this.logService.save(JSON.stringify(dominios), 'BirthCityComponent.getDomainCity.getDomainService');
      if (dominios?.length > 0) {
        this.birthCity = this.orderList(dominios, this.journeyService.registratioJourney.data.personalData?.cityOfBirth);
        this.showRetry = false;
        this.loading = false;
        this.analyticsData();
        this.sendTrackGA4LoadPage();
      } else {
        this.loading = false;
        this.showRetry = true;
        this.headerFocus();
        this.sendTrackGA4LoadPageError();
      }
    }).catch((err) => {
      this.logService.save(err, 'BirthCityComponent.getDomainCity.getDomainService,err')
      this.loading = false;
      this.showRetry = true;
      this.sendTrackGA4LoadPageError();
    }).finally(() => {
      this.loading = false;
      this.headerFocus();
    });
  }

  orderList(data: RadioModel[], selectedItem: string): RadioModel[] {
    if (selectedItem !== '') {
      const dataOrder = data;
      dataOrder.sort(ValueSort.compareFn);
      return [
        ...dataOrder.filter(value => value.key === selectedItem),
        ...dataOrder.filter(value => value.key !== selectedItem)
      ];
    }
    return data;
  }

  scrollContentToTop() {
    setTimeout(() => this.content?.nativeElement.scrollTo(0, 0), 200);
  }

  backPage() {
    this.analyticsEventClique();
    this.back();
  }
  
  changeValue() {
    this.birthCity = this.orderList(this.birthCity, this.selectedItem);
  }
}
